var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-item",style:({'font-size':_vm.fontSize+'px'})},[_vm._l((_vm.nums),function(item,index){return [_c('li',{key:index,class:{'number-item': !isNaN(item), 'mark-item': isNaN(item) },style:({'background-color':_vm.backgroundImage?'':_vm.backgroundColor,
  'background-image':'url('+_vm.backgroundImage+')',
  'border-color':_vm.borderColor,
  height:_vm.itemHeight+ 'px',
  width:_vm.itemWidth+ 'px',
  'margin-right':index<_vm.nums.length-1?_vm.gap+'px':'0px'})},[(!isNaN(item))?_c('span',[_c('i',{ref:"numberItem",refInFor:true,style:({color:_vm.color,top:0})},[_vm._v("0123456789")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mid-line",style:({'background-color':_vm.borderColor,width:_vm.itemWidth+ 'px'})})])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25036664","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/h-number-flop.vue
// module id = null
// module chunks = 